import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMiMateria } from '../../types/miRecurso';

interface IMisMateriasPageState {
	materias: IMiMateria[];
	selectedMateriaId: number | null;
	ingresarCodigoDialogOpen: boolean;
	codigoError: string | null;
}

const initialState: IMisMateriasPageState = {
	materias: [],
	selectedMateriaId: null,
	ingresarCodigoDialogOpen: false,
	codigoError: null,
};

export const misMateriasPageSlice = createSlice({
	name: 'misMateriasPage',
	initialState,
	reducers: {
		setMaterias: (state, action: PayloadAction<IMiMateria[]>) => {
			state.materias = action.payload;
		},
		enrollMateria: (state, action: PayloadAction<IMiMateria>) => {
			state.materias.push(action.payload);
		},
		setSelectedMateriaId: (state, action: PayloadAction<number | null>) => {
			state.selectedMateriaId = action.payload;
		},
		setIngresarCodigoDialogOpen: (state, action: PayloadAction<boolean>) => {
			state.ingresarCodigoDialogOpen = action.payload;
			if (!action.payload) state.codigoError = null;
		},
		setCodigoError: (state, action: PayloadAction<string | null>) => {
			state.codigoError = action.payload;
		},
		resetMisMateriasPage: () => initialState,
	},
});

export const {
	setMaterias,
	enrollMateria,
	setSelectedMateriaId,
	setIngresarCodigoDialogOpen,
	setCodigoError,
	resetMisMateriasPage,
} = misMateriasPageSlice.actions;

export default misMateriasPageSlice.reducer;
